import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BasePageComponent } from '../base-page.component';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Store } from '@ngrx/store';
import { MACMSStoreState } from '@nx-monorepo/cms-base/store';

@Component({
  selector: 'pk-help-user-page',
  templateUrl: './pk-help-user-page.component.html',
  styleUrls: ['./pk-help-user-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PkHelpUserPage extends BasePageComponent implements OnInit, OnDestroy, AfterViewInit {

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(store$: Store<MACMSStoreState.State>,
              route: ActivatedRoute,
              private _fuseProgressBarService: FuseProgressBarService,) {
    super(store$, route);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this._fuseProgressBarService.hide();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
